import { Modal } from '@salecycle/ui-component-library';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { StartDateAndTimeControl } from './StartDateAndTimeControl';
import { EndDateAndTimeControl } from './EndDateAndTimeControl';

export interface ScheduledDatesModalProps {
  open: boolean;
  onClose: () => void;
  id: string;
}

export const ScheduledDatesModal = ({ open, onClose, id }: ScheduledDatesModalProps) => {
  const { t } = useTranslation('campaigns');
  const theme = useTheme();

  return (
    <Modal
      heading={t('onsite.editor.workflow.displayWebContentMessage.segmentScheduling.datesModal.heading')}
      variation="clean"
      isOpen={open}
      onCloseButtonClicked={onClose}
      cancelButtonLabel={t('onsite.editor.workflow.displayWebContentMessage.segmentScheduling.datesModal.done')}
      cancelButtonAriaLabel={t('onsite.editor.workflow.displayWebContentMessage.segmentScheduling.datesModal.done')}
      onOkButtonClicked={onClose}
      okButtonLabel={t('onsite.editor.workflow.displayWebContentMessage.segmentScheduling.datesModal.done')}
      okButtonAriaLabel={t('onsite.editor.workflow.displayWebContentMessage.segmentScheduling.datesModal.done')}
      overflow="visible"
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: theme.designToken.spacing3 }}>
        <StartDateAndTimeControl messageId={id} key="segment-schedule-start" />
        <EndDateAndTimeControl messageId={id} key="segment-schedule-end" />
      </div>
    </Modal>
  );
};
